<script setup>
  const { fights, firstSection } = defineProps(['fights', 'firstSection']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap wide :class="{ firstSection }">
    <BigTitle h1>
      <slot />
    </BigTitle>
    <Foreground>
      <div class="fights">
        <PastFightCard v-for="fight in fights" :fight="fight" />
      </div>
    </Foreground>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    padding-top: px(90);
    padding-bottom: px(128);
    margin-bottom: -$content-padding-bottom;

    background-color: $black;

    .foreground {
      @include break-min-large {
        @include column(2, 11);
      }
    }

    &.firstSection {
      @include top-padding;
    }

    .fights {
      display: flex;
      flex-direction: column;

      gap: px(48);
    }

    @include break-medium {
      .fights {
        gap: $margin-medium;
      }
    }

    @include break-small {
      .fights {
        gap: $margin-small;
      }
    }

    @include break-phone {
      .fights {
        gap: px(32);
      }
    }
  }
</style>
